module.exports = __webpack_public_path__ + "static/img/feature-3.347931a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/zh/pc/imgs/feature-3.jpg
// module id = GeUg
// module chunks = 13